import { cn } from '@/shared/lib/utils'

// Three canonical sizes - keep the scale tight so each one has a clear
// role and the same loading state always looks the same:
//   sm (16px) - inline in a button or table cell
//   md (24px) - centered in a card / section
//   lg (32px) - centered on a full page or route
type Size = 'sm' | 'md' | 'lg'
const sizes: Record<Size, string> = { sm: 'h-4 w-4', md: 'h-6 w-6', lg: 'h-8 w-8' }

// Colour: the SVG paints with `currentColor`, so a Spinner takes the text
// colour of whatever contains it. That is right inside a Button (white on a
// filled one, brand-orange on an outline one) and wrong everywhere else,
// where it inherits the near-black body text and the loader reads as a
// stray black smudge rather than the brand.
//
// So: a Spinner inside a Button needs nothing. A standalone Spinner must
// pass a colour, normally `className="text-brand-orange"`.
export function Spinner({ size = 'md', className }: { size?: Size; className?: string }) {
  return (
    <svg
      className={cn('animate-spin', sizes[size], className)}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
      />
    </svg>
  )
}
